import { ComponentProps } from 'react';
import { DEFAULT_FIVERR_LOCALE } from '@fiverr-private/localization';
import { UserData } from '@fiverr-private/homepage_common_types';
import { statsFunctionWrapper } from '@fiverr-private/homepage_utils';
import { PersonalizedData } from '../../../components/RowSections/components/PersonalizedRowSection/PersonalizedRowSection.types';
import { TranslationState } from '../../../hooks/useTranslationToggle.types';
import { translateUgcContent } from '../personalizedContent';
import { UGCContext } from '../../../context/ugc/ugc.context';
import { buildSourceInfo } from './buildSourceInfo';

export const shouldTranslate = (targetLocale: string) => targetLocale !== DEFAULT_FIVERR_LOCALE;

export const translateAndStoreUgc = async ({
    userData,
    originalPersonalizedContent = {},
    addUgcData,
    targetLocale,
    grafanaKey,
}: {
    userData?: UserData;
    originalPersonalizedContent: PersonalizedData | Record<string, never> | undefined;
    addUgcData: ComponentProps<typeof UGCContext.Provider>['value']['addUgcData'];
    targetLocale: string;
    grafanaKey: string;
}) => {
    const sourceInfo = buildSourceInfo({
        user: userData,
    });
    let translatedPersonalizedContent:
        | { personalizedContent: PersonalizedData }
        | TranslationState['ugcMap']['translated']
        | Record<string, never> = {};

    const fetcher = () =>
        translateUgcContent({
            ugcMap: {
                original: {
                    personalizedContent: { sections: originalPersonalizedContent?.sections ?? {} },
                },
            },
            targetLocale,
            sourceInfo,
        });

    translatedPersonalizedContent = await statsFunctionWrapper(fetcher, grafanaKey)();

    addUgcData({
        translated: {
            personalizedContent: {
                sections: translatedPersonalizedContent?.personalizedContent?.sections ?? {},
            },
        },
        original: {
            personalizedContent: {
                sections: originalPersonalizedContent?.sections ?? {},
            },
        },
    });
};
